import { GtmService } from 'tradera/services/google-tagmanager/google-tagmanager-service';
import { HOVER_MENUS } from './hover-menu/constants';
import HoverMenu from './hover-menu/hover-menu';
import hoverMenuStyles from './hover-menu/hover-menu.module.scss';
import { CurrencySelect } from 'tradera/components/localization/currency-select';
import { selectPreferredCurrency } from 'tradera/state/multi-currency/selectors';
import { useTranslator } from 'tradera/lang/translate';
import { useAppSelector } from 'tradera/state/hooks';
import { classNames } from 'tradera/utils/class-names';
import { Button } from 'tradera/components/atoms/button/button';

type CurrencyLinkProps = {
    onClick: (e: React.MouseEvent<HTMLElement>, menu: string) => void;
    onClickMenuOption: () => void;
    mouseOver: (menu: string) => void;
    mouseOut: () => void;
    showMenu: boolean;
};

export const CurrencyLink = ({
    onClick,
    onClickMenuOption,
    mouseOver,
    mouseOut,
    showMenu,
}: CurrencyLinkProps) => {
    const { t } = useTranslator();
    const preferredCurrency = useAppSelector(selectPreferredCurrency);

    return (
        <div
            className="position-static"
            onMouseEnter={() => mouseOver(HOVER_MENUS.CURRENCY)}
            onMouseLeave={mouseOut}>
            <Button
                theme="text"
                className={classNames('slim-header__button', {
                    active: showMenu,
                })}
                onClick={(e) => {
                    GtmService.trackAction(
                        'Top navigation',
                        'Currency menu',
                        'Open/Close',
                    );
                    onClick(e, HOVER_MENUS.CURRENCY);
                }}>
                {preferredCurrency.shortName}
            </Button>
            <HoverMenu
                className={classNames(
                    hoverMenuStyles.alignRight,
                    'hover-currency-menu',
                )}
                showMenu={showMenu}>
                <div className="mt-3">
                    <CurrencySelect
                        onCurrencySelected={onClickMenuOption}
                        inProfileMenu={false}
                        title={t('siteHeader_currency')}
                    />
                </div>
            </HoverMenu>
        </div>
    );
};
